const startYear = 2019;
const currentYear = new Date().getFullYear();
const years = Array.from({length: currentYear - startYear + 1}, (_, index) => {
  const year = startYear + index;
  return {
    value: year,
    label: year.toString(),
    selected: year === currentYear
  };
});

export default {
  status                    : {
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  statuses: [
    { label: 'Enabled',  value: 'Enabled' },
    { label: 'Disabled',  value: 'Disabled' }
  ],
  contractStatuses: [
    { label: 'Draft',  value: 'Draft' },
    { label: 'Approved',  value: 'Approved' },
    { label: 'Npl',  value: 'Npl' },
    { label: 'NplReturn',  value: 'NplReturn' },
    { label: 'Close',  value: 'Close' }
  ],
  curriculumPeriods: [
    { label: '1 Year',  value: 1 },
    { label: '2 Year',  value: 2 },
    { label: '3 Year',  value: 3 },
    { label: '4 Year',  value: 4 },
    { label: '5 Year',  value: 5 },
    { label: '6 Year',  value: 6 }
  ],
  contractPeriods: [
    { label: '0',  value: 0 },
    { label: '5',  value: 5 },
    { label: '10',  value: 10 },
    { label: '15',  value: 15 },
    { label: '20',  value: 20 },
  ],
  loanTypes: [
    { id: 1, value: 'Interest', label: 'ผ่อนชำระดอกเบี้ยระหว่างเรียน',  description: 'แบบที่ 1	ผู้กู้จะต้องชำระคืนเงินต้นพร้อมดอกเบี้ยในอัตราร้อยละ ... ต่อปี ภายในกำหนดระยะเวลา ไม่เกิน ... เดือน นับจากวันที่ผู้กู้สำเร็จการศึกษา  โดยผู้กู้จะต้องผ่อนชำระเป็นรายเดือน เดือนละ ..........บาท โดยชำระภายในวันที่ 5 ของทุกเดือน และชำระงวดแรกในเดือนถัดจากเดือนที่ผู้กู้สำเร็จการศึกษาเป็นต้นไป' },
    { id: 2, value: 'PrincipleGraduate', label: 'ผ่อนชำระเงินต้นและดอกเบี้ยเมื่อเรียนจบ', description: 'แบบที่ 2	ผู้กู้จะต้องชำระคืนเงินต้นพร้อมดอกเบี้ยในอัตราร้อยละ ... ต่อปี ภายในกำหนดระยะเวลา ไม่เกิน 60 เดือน นับจากวันที่ผู้กู้สำเร็จการศึกษา  โดยผู้กู้จะต้องผ่อนชำระเป็นรายเดือน เดือนละ ..........บาท โดยชำระภายในวันที่ 5 ของทุกเดือน และชำระงวดแรกในเดือนถัดจากเดือนที่ผู้กู้สำเร็จการศึกษาเป็นต้นไป' },
    { id: 3, value: 'Principle', label: 'ผ่อนชำระเงินต้นและดอกเบี้ยระหว่างเรียน',  description: 'แบบที่ 3 ผู้กู้จะต้องชำระดอกเบี้ยอัตราร้อยละ ... ต่อปี ภายในกำหนดระยะเวลาไม่เกิน...........เดือน โดยภายใน 12 เดือนแรก ชำระเดือนละ..........................บาท และเดือนที่ 13 เป็นต้นไป เดือนละ........................ บาท จนกว่าจะครบกำหนด โดยชำระภายในวันที่ 5 ของทุกเดือน' },
    { id: 4, value: 'Restructuring', label: 'ปรับโครงสร้างหนี้',  description: '' },
  ],
  restructuringTypes: [
    {id : 1, value: 'Normal', label: 'ปรับโครงสร้างหนี้ (ปกติ)'},
    {id : 2, value: 'ContractNegotiation', label: 'ปรับโครงสร้างหนี้ (สัญญาประนีประนอม)'},
    {id : 3, value: 'JudicialCourt', label: 'ปรับโครงสร้างหนี้ (ศาลพิพากษา)'},
    {id : 4, value: 'OldCondition', label: 'ปรับโครงสร้างหนี้ (เงื่อนไขเดิม)'},
    {id : 5, value: 'SpecialCondition', label: 'ปรับโครงสร้างหนี้ (เงื่อนไขพิเศษ)'},
  ],
  loanDetailTypes: [
    { value: 'RegistrationFee', label: 'Registration Fee' },
    { value: 'TuitionFee', label: 'Tuition Fee' },
    { value: 'CostOfLiving', label: 'Cost Of Living' }
  ],
  interestTypes: [
    { id: 1, value: 'Principle', label: 'Principle' },
    { id: 2, value: 'PrincipleAndInterest', label: 'Principle And Interest' },
    { id: 3, value: 'PrincipleInPeriod', label: 'Principle In Period' },
  ],
  debtCollectionFeeTypes: [
    { value: 'None', label: 'None' },
    { value: 'Fixed', label: 'Fixed' },
    { value: 'Custom', label: 'Custom' },
  ],
  hierarchys: [
    { value: 1, label: "In Due" },
    { value: 2, label: "1-45 วัน" },
    { value: 3, label: "46-120 วัน" },
    { value: 4, label: '>=121 วัน' },
  ],
  paymentRoundTypes: [
    { value: 'None', label: 'None' },
    { value: 'Interest', label: 'Interest' },
    { value: 'InterestFixed', label: 'InterestFixed' },
    { value: 'Principle', label: 'Principle' },
  ],
  overDueTypes: [
    { value: 'Now', label: 'Now' },
    { value: 'Before', label: 'Before' }
  ],
  actionTypes: [
    // { value: 'AddLoan', label: 'AddLoan' },
    // { value: 'AddLoanPlan', label: 'AddLoanPlan' },
    // { value: 'AddFee', label: 'AddFee' },
    // { value: 'AddPaymentRound', label: 'AddPaymentRound' },
    // { value: 'AddPayment', label: 'AddPayment' },
    { value: 'AddInterestRate', label: 'AddInterestRate' },
    { value: 'EditEducationStatus', label: 'EditEducationStatus' },
  ],
  transactionTypes: [
    { value: 'AddRestructuring', label: 'AddRestructuring' },
    { value: 'AddLoanDetail', label: 'AddLoanDetail' },
    { value: 'AddFeeDetail', label: 'AddFeeDetail' },
    { value: 'AddPayment', label: 'AddPayment' },
    { value: 'AddDaily', label: 'AddDaily' }
  ],
  transactionDisplays: [
    { value: 'All', label: 'ทั้งหมด' },
    { value: 'LoanDetail', label: 'เพิ่มเงินกู้' },
    { value: 'FeeDetail', label: 'เพิ่มค่าธรรมเนียม' },
    { value: 'Payment', label: 'ชำระเงิน' },
    { value: 'Monthly', label: 'รายเดือน' },
    { value: 'AllAction', label: 'เฉพาะดำเนินการ' },
  ],
  reportTypes: [
    { value: 'Summary', label: 'รายงานสรุป' },
    { value: 'SummaryForecast', label: 'รายงานคำนวนล่วงหน้า' },
    { value: 'SummaryRemittance', label: 'รายงานสรุปเงินนำส่ง' },
  ],
  reportTypesExecutive: [
    { value: 'LoanInfo', label: 'รายการข้อมูลลูกหนี้' },
    { value: 'LoanTracking', label: 'ข้อมูลการติดตามหนี้' },
    { value: 'LoanClassify', label: 'ข้อมูลลูกหนี้จัดชั้น แยกประเภท' },
  ],
  years,
  months: [
    { value: 1, label: 'มกราคม', selected: false },
    { value: 2, label: 'กุมภาพันธ์', selected: false },
    { value: 3, label: 'มีนาคม', selected: false },
    { value: 4, label: 'เมษายน', selected: false },
    { value: 5, label: 'พฤษภาคม', selected: false },
    { value: 6, label: 'มิถุนายน', selected: false },
    { value: 7, label: 'กรกฎาคม', selected: false },
    { value: 8, label: 'สิงหาคม', selected: false },
    { value: 9, label: 'กันยายน', selected: false },
    { value: 10, label: 'ตุลาคม', selected: false },
    { value: 11, label: 'พฤศจิกายน', selected: false },
    { value: 12, label: 'ธันวาคม', selected: false }
  ],
  importCustomerTypes: [
    { label: 'ไฟล์นำเข้าผู้กู้',  value: 'Borrowers' },
    { label: 'ไฟล์นำเข้าผู้ค้ำประกัน',  value: 'Sureties' },
    // { label: 'ไฟล์แก้ไขข้อมูลผู้กู้',  value: 'BorrowersUpdate' },
    // { label: 'ไฟล์แก้ไขข้อมูลผู้ค้ำประกัน',  value: 'SuretiesUpdate' },
  ],
  importAccountingTypes: [
    { label: 'ไฟล์นำเข้าสัญญา',  value: 'Contracts' },
    { label: 'ไฟล์นำเข้าการโอนเงิน',  value: 'LoanDetails' },
    { label: 'ไฟล์นำเข้าแผนการโอนเงินนำส่ง',  value: 'LoanDetailPlans' },
    { label: 'ไฟล์นำเข้าการชำระเงิน',  value: 'Payments' },
    { label: 'ไฟล์นำเข้าบันทีกการติดตามหนี้',  value: 'TrackDownDebts' },
    { label: 'ไฟล์นำเข้าข้อมูลผู้ค้ำประกัน',  value: 'ContractsSureties' },
    { label: 'ไฟล์อัพเดทสัญญาหนี้สูญ',  value: 'BadDebts' },
    // { label: 'ไฟล์แก้ไขอัตราดอกเบี้ย EIR',  value: 'ContractsInterestRateEir' },
    // { label: 'ไฟล์แก้ไขวันที่คาดว่าจะจบการศึกษา',  value: 'ContractsForecastDate' },
    // { label: 'ไฟล์แก้ไขเลขที่บัญชี',  value: 'ContractsAccoNo' },
    // { label: 'ไฟล์นำเข้าสัญญาปรับโครงสร้างหนี้',  value: 'ContractsRestructuring' },
  ],
  importCustomTypes: [
    { label: 'ไฟล์สร้าง QR CODE',  value: 'GenerateQrCode' },
  ],
  educationStatuses: [
    { label: 'Normal',  value: 'Normal' },
    { label: 'Graduated',  value: 'Graduated' },
    { label: 'BreachOfPromise',  value: 'BreachOfPromise' }
  ],
  paymentFilters:{
    project: "",
    loanType: "",
    curriculum: "",
    contractNo: "",
    contractName: "",
    overDueType: ""
  },
  transactionFilters:{
    year: "",
    educationStatus: "",
    loanType: "",
    curriculum: "",
    contractNo: "",
    contractName: "",
    agingNumber: 121,
    overDueType: ""
  },
  expenseTypes: [
    { value: 'ContractFee', label: 'Contract Fee' },
    { value: 'TaxAmount', label: 'Tax Amount' },
    { value: 'ProcessingFee', label: 'Processing Fee' },
    { value: 'CourtOrderExpense', label: 'Court Order Expense' }
  ],
  notificationTypes: [
    { value: 'Payment', label: 'Payment' },
    { value: 'LoanTransfer', label: 'Loan Transfer' },
    { value: 'OutstandingBalanceReminder', label: 'Outstanding Balance Reminder' },
    { value: 'Sms', label: 'Sms' },
    { value: 'PaymentExpense', label: 'Payment Expense' },
    { value: 'Custom', label: 'Custom' },
  ],
  feeTypes: [
    { value: 'DebtCollectionFee', label: 'Debt Collection Fee' },
    { value: 'DebtCollectionFeeCustom', label: 'Debt Collection Fee Custom' },
    { value: 'ReminderLetter', label: 'Reminder Letter' }
  ],
  period: {},
  periods: [],
  degree: {},
  degrees: [],
  degreeOptions: [],
  project: {},
  projects: [],
  projectOptions: [],
  campus: {},
  campuses: [],
  campusOptions: [],
  faculty: {},
  faculties: [],
  curriculum: {},
  curriculums: [],
  curriculumsOptions: [],
  curriculumExternal: {},
  curriculumExternals: [],
  source: {},
  sources: [],
  prefix: {},
  prefixOptions: [],
  prefixes: [],
  relationship: {},
  relationshipOptions: [],
  relationships: [],
  nationality: {},
  nationalities: [],
  race: {},
  races: [],
  religion: {},
  religions: [],
  occupation: {},
  occupations: [],
  signer: {},
  signers: [],
  signerOptions: [],
  notificationTemplate: {},
  notificationTemplates: [],
  notificationTemplateOptions: [],

  debtRestructurePolicy: {},      // เก็บข้อมูล Policy ตัวเดียว
  debtRestructurePolicies: [],    // เก็บรายการ Policy ทั้งหมด
  debtRestructurePolicyOptions: [], // เก็บ options (ใช้ทำ select box/dropdown)

  measure: {},        // เก็บข้อมูล Measure ตัวเดียว
  measures: [],       // เก็บรายการ Measure ทั้งหมด
  measureOptions: [], // เก็บ options ของ Measure

  subMeasure: {},        // เก็บข้อมูล SubMeasure ตัวเดียว
  subMeasures: [],       // เก็บรายการ SubMeasure ทั้งหมด
  subMeasureOptions: [], // เก็บ options ของ SubMeasure
}
